var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M173.535 22.63c3.054-.272 4.766 3.415 2.569 5.537l-87.131 83.976c-2.602 2.506-6.786-.415-5.251-3.671l22.764-48.227c6.35-14.986 6.511-28.2-4.362-31.44l71.411-6.175z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M25.882 35.397c-3.716.319-4.072 5.538-.453 6.367l81.057 18.48c6.349-14.985 6.511-28.23-4.362-31.438l-76.242 6.59z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "aus-super-symbol-tonal-white_svg__paint0_linear_2255_22113",
  x1: 43.383,
  x2: 110.858,
  y1: 60.462,
  y2: 21.552,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.115,
  stopColor: "currentColor"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.921,
  stopColor: "currentColor",
  stopOpacity: 0.09
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "currentColor",
  stopOpacity: 0
})));

var SvgAusSuperSymbolTonalWhite = function SvgAusSuperSymbolTonalWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 200 136",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAusSuperSymbolTonalWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/aus-super-symbol-tonal-white.51d0f815.svg";
export { ForwardRef as ReactComponent };